/**
 * Shared types for frontend logging
 */

/** Log severity levels */
export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

/** Log severity levels in order of increasing severity */
export const LOG_LEVELS: readonly LogLevel[] = ['debug', 'info', 'warn', 'error'] as const;

/** Structured context for log entries */
export interface LogContext {
  // Error details
  error_name?: string;
  error_stack?: string;
  error_code?: string;
  error_event_id?: string;
  error_fingerprint?: string;
  error_reporter?: string;

  // Request context - use trace_id for consistency with Cloud Logging
  trace_id?: string;
  url?: string;
  method?: string;
  status_code?: number;
  page_url?: string;
  source_file?: string;
  error_line?: number;
  error_col?: number;

  // User context (auto-populated if not provided)
  user_id?: string;
  organization_id?: string;
  session_id?: string;
  page_view_id?: string;

  // App context
  component?: string;
  action?: string;

  // Environment (auto-populated)
  user_agent?: string;
  app_version?: string;
  release?: string;
  commit_hash?: string;
  build_time?: string;
  environment?: string;
  client_locale?: string;
  client_timezone?: string;

  // Custom fields
  [key: string]: unknown;
}

/** Internal log entry structure */
export interface LogEntry {
  level: LogLevel;
  message: string;
  timestamp: string;
  context?: LogContext;
}
